import Amt from "components/recoveries/named-recoveries/controls/amt"
import DeleteConfirmation from "components/modal/delete-confirmation"
import ProRataRecovery from "components/recoveries/named-recoveries/controls/pro-rata-recovery"
import TenantMgmtFee from "components/recoveries/named-recoveries/controls/tenant-mgmt-fee"

export default {
  Amt,
  DeleteConfirmation,
  ProRataRecovery,
  TenantMgmtFee
}
